import { render } from "./AddEditCategoryModal.vue?vue&type=template&id=1dfc39c9&scoped=true"
import script from "./AddEditCategoryModal.vue?vue&type=script&lang=js"
export * from "./AddEditCategoryModal.vue?vue&type=script&lang=js"

import "./AddEditCategoryModal.vue?vue&type=style&index=0&id=1dfc39c9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dfc39c9"]])

export default __exports__